// SubscriptionSize.js
import flatstore from 'flatstore';
import parse from 'html-react-parser';
import { isNil } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getSubscriptionPaths, localStorageUtil } from '../../../utils/functions';
import {
    getSubscriptionProductList
} from "../../../utils/services";


function SubscriptionSize({subscription, isResetting}) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const paths = getSubscriptionPaths();
    const type = 'customize';

    // Simplified state initialization
    const [size, setSize] = useState(localStorageUtil.getItem('subscription')?.size || 'small');

    const [submissionError, setSubmissionError] = useState('');

    const [data, setData] = useState([]);

    useEffect(() => {
        if( ! type ){
            navigate(paths.base || '/');
        }
    }, []);

    useEffect(() => {
        if (isNil(subscription)) {
            getSubscriptionProductList();
        }
        if (subscription && !isNil(subscription)) {
            setData(subscription);
        }
    }, [subscription]);

    const handleSubmit = () => {
        if (size) {
            localStorageUtil.updateObjectItem('subscription', { size: size });
            navigate(paths.steps[type] || '/'); // Fallback to root if path is undefined
            setSubmissionError('');
        } else {
            setSubmissionError('Please select a size for your subscription.');
        }
    };

    const handleSizeChange = (e) => setSize(e.target.value);

    // Update progress based on selections
    let progressBarWidthPercentage = 0;
    if (size) {
      progressBarWidthPercentage = 25;
    }

    // ProgressBar
    const progressBarWidth = {
        width: `${progressBarWidthPercentage}%`,
    };

    return (
        <div className="subscription-box">

            <div className='progress-bar'>
                <div className='fill' style={progressBarWidth}></div>
            </div>

            {submissionError && (
                <div className="response error">
                {submissionError}
                </div>
            )}

            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-md-10'>

                        <div className="container py-4">
                            <div className="row">
                                <div className="col primary-title">
                                    {isResetting ? (
                                        <>
                                            <h2>{t(`subscription.${type}.size-title-update-subscription.title`)}</h2>
                                            <p>{t(`subscription.${type}.size-title-update-subscription.subtitle`)}</p>
                                        </>
                                    ) : (
                                        <>
                                            <h2>{t(`subscription.${type}.size-title.title`)}</h2>
                                            <p>{t(`subscription.${type}.size-title.subtitle`)}</p>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="row justify-content-center">
                            {['small', 'large'].map((sizeOption, index) => (
                                <div key={index} className="col-12 col-md-6">
                                <label className="subscription__select" htmlFor={sizeOption}>
                                    <input
                                    type="radio"
                                    id={sizeOption}
                                    name="size"
                                    value={sizeOption}
                                    checked={size === sizeOption}
                                    onChange={handleSizeChange}
                                    />
                                    <div className="checkbox">
                                    <span></span>
                                    </div>
                                    <div className="body">
                                        <div className="title">
                                            <h3 className="heading">{t(`subscription.${type}.${sizeOption}.title`)}</h3>
                                            <p>{t(`subscription.${type}.${sizeOption}.subtitle`)}</p>
                                            <div className="desc">
                                                {parse(t(`subscription.${type}.size.${sizeOption}`))}
                                            </div>
                                        </div>
                                    </div>
                                </label>
                                </div>
                            ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="subscription__cta">
                <button className="btn btn--red" onClick={handleSubmit}>{t('subscription.'+ type +'.cta')}</button>
            </div>

        </div>
    );
}

export default flatstore.connect(['subscription'])(SubscriptionSize);